import { VideoFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateVideoFlightArgs,
    getDefaultVideoFlightCreateArgs,
    UpdateVideoFlightArgs,
} from "@nova/serializer/src/client/validators/flights/video"
import { selectVideoFlights } from "features/entity-caching/flights/selectors"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { setFlightId } from "features/map/control/slice"
import { deleteUploadSet } from "plugins/Video/FMV/VideoSlice"
import { SampleDataFlightKey } from "@nova/constants"
import { selectSingleLayer, setActiveLayerId } from "panels/content/side-panel/slice.new"

const {
    create: createVideoFlight,
    update: updateVideoFlight,
    delete: deleteVideoFlight,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    VideoFlight, // entity type
    CreateVideoFlightArgs, // create args to send to server
    ["createdBy"], // create args required by action
    UpdateVideoFlightArgs, // update args
    { sampleDataFlightKey?: SampleDataFlightKey },
    { sampleDataFlightKey?: SampleDataFlightKey }
>("VideoFlight")

export const addVideoFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            const state = store.getState()
            const flights = selectVideoFlights(state)
            const name = `Video Flight ${Object.values(flights).length + 1}`
            const args = {
                name,
                id: randomUUID(),
                demoId: !!context?.sampleDataFlightKey ? "doesnt-matter" : undefined,
            }
            const optimisticData = {
                ...args,
                ...getDefaultVideoFlightCreateArgs(state.project.data),
                ...data,
            }
            createVideoFlight(
                socket,
                { ...args, ...data },
                { sampleDataFlightKey: context?.sampleDataFlightKey }
            )
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["videoFlights"],
                })
            )

            store.dispatch(selectSingleLayer({ id: optimisticData.id }))
            store.dispatch(setFlightId(optimisticData.id))
            store.dispatch(setActiveLayerId({ id: optimisticData.id }))
        })
        .addCase(updateAction, (store, { payload: { id, updates, context } }, socket) => {
            updateVideoFlight(socket, id, updates, { ...context })

            if (context?.sampleDataFlightKey) updates.demoId = "doesnt-matter"

            store.dispatch(updateEntitySocket({ updates, path: ["videoFlights", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            const dispatch = store.dispatch
            dispatch(deleteUploadSet({ flightId: id }))
            deleteVideoFlight(socket, id, {})
            dispatch(deleteEntitySocket({ path: ["videoFlights", { id }] }))
        })
export {
    createAction as createVideoFlight,
    updateAction as updateVideoFlight,
    deleteAction as deleteVideoFlight,
}
